import React, { useEffect, useState } from "react";
import { MetaTags } from "react-meta-tags";
import { Card, CardBody, Col, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import BreadcrumbWithLink from "../../components/Common/BreadcrumbWithLink";
import RemoteDataTable from "../../components/shared-components/RemoteTable/data-table";
import { MockBusinessEmailTemplateData } from "./mock-business-email-template-data";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  deleteBusinessEmailTemplate,
  getBusinessEmailTemplates,
  resetListBusinessEmailTemplates
} from "../../store/business-email-templates/action";
import { userRecordStatusMode } from "../GeneralInfo/BusinessUnit/utils";
import PropTypes from "prop-types";
import { resetListIssueInvoice } from "../../store/issue-invoice/actions";
import { useHistory } from "react-router-dom";
import ConfirmModal from "../../components/shared-components/ConfirmModal";

const BusinessEmailTemplateList = props => {

  const { filterList } = props;

  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const history = useHistory();

  const businessEmailTemplatesData = useSelector(state => state.businessEmailTemplatesData);
  const {
    loadingList,
    errorList,
    list: businessEmailTemplatesList,
  } = businessEmailTemplatesData;

  const [list, setList] = useState(null);
  const [columns, setColumns] = useState([]);
  const [columnsTable, setColumnsTable] = useState([]);
  const [dataDeleteUser, setDataDeleteUser] = useState({
    userId: null,
  });

  const { t, i18n } = useTranslation(["businessEmailTemplate"]);
  const [deleteEmailTemplateModal, setDeleteEmailTemplateModal] = useState(false);


  const initColumns = [
    {
      dataField: "email_type",
      text: t("table.email_type"),
      sort: true,
    },
    {
      dataField: "name",
      text: t("table.name"),
      sort: true,
    },
    {
      dataField: "title",
      text: t("table.title"),
      sort: true,
    },
    {
      dataField: "valid",
      text: t("table.valid"),
      sort: false,
      formatter: (cell, row) => {

        return cell ?
          <i className='bx bx-check text-success font-size-18' /> :
          <i className='bx bx-x text-danger font-size-18' />;

      },
    },
  ];

  const onRowsSelect = data => {
    console.log("onRowsSelect", data);
  };

  const clickEditEmailTemplateHandler = (row) => {
    history.push(`/business-email-templates/edit/${row.id}`);
  }

  // click button column action delete
  const clickDeleteUserHandler = (row, index) => {
    setDataDeleteUser({ userId: row.id });
    toggleDeleteEmailTemplateModal();
  };

  const clickDeleteEmailTemplateHandler = () => {
    dispatch(deleteBusinessEmailTemplate(dataDeleteUser.userId));
    setDeleteEmailTemplateModal(!deleteEmailTemplateModal);
  }

  const clickCreateEmailTemplateHandler = () => {
    history.push('/business-email-templates/create');
  }

  const onSearchAllHandle = (value) => {
    businessEmailTemplatesList.params.keywords = value;
    dispatch(getBusinessEmailTemplates(businessEmailTemplatesList.params));
  }

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    businessEmailTemplatesList.params.sort = sortField
      ? sortOrder + sortField
      : businessEmailTemplatesList.params.sort;
    businessEmailTemplatesList.params.columnFilter = columnFilter || {};
    businessEmailTemplatesList.params.currentPage = page || 1;
    businessEmailTemplatesList.params.perPage = sizePerPage || 10;
    dispatch(getBusinessEmailTemplates(businessEmailTemplatesList.params));
  };

  const toggleDeleteEmailTemplateModal = () => {
    setDeleteEmailTemplateModal(!deleteEmailTemplateModal);
  };

  useEffect(() => {
    // Set default value to page|sizePerPage when change Language
    businessEmailTemplatesList.params.currentPage = 1;
    businessEmailTemplatesList.params.perPage = 10;
    businessEmailTemplatesList.params.columnFilter = { ...filterList };
    dispatch(getBusinessEmailTemplates(businessEmailTemplatesList.params));

    initColumn();

    return () => {
      dispatch(resetListBusinessEmailTemplates());
    };
  }, [dispatch, t]);

  useEffect(() => {
    if (businessEmailTemplatesList) {
      setColumnsTable(initColumns);
    }

    if (businessEmailTemplatesList.columnsVisibleHaveCode) {
      initColumn();
    }

  }, [businessEmailTemplatesList]);

  useEffect(() => {
    if (errorList && errorList.message) {
      addToast(errorList.message, {
        appearance: "error",
        autoDismiss: true,
      });
      dispatch(resetListBusinessEmailTemplates());
    }
  }, [addToast, dispatch, errorList]);

  useEffect(() => {
    setColumns(initColumns);

  }, [])

  const initColumn = () => {
    if (businessEmailTemplatesList.columnsVisible) {
      for (const item of initColumns) {
        if (businessEmailTemplatesList.columnsVisible[item.dataField] !== undefined) {
          item.hidden = !businessEmailTemplatesList.columnsVisible[item.dataField];
        }
      }
    }
    setColumnsTable(initColumns);
  };

  const listRowAction = [
    {
      icon: <i className="fas fa-pen fa-lg text-primary" />,
      text: t("table.actions.edit.user"),
      onClick: clickEditEmailTemplateHandler,
    },
    {
      icon: <i className="fas fa-lg fa-trash-alt text-danger" />,
      text: t("table.actions.delete.user"),
      conditionVisible: {
        record_status: [userRecordStatusMode.ACTIVE],
      },
      onClick: clickDeleteUserHandler,
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.list")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.list")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {businessEmailTemplatesList &&
                  <RemoteDataTable
                    onRowsSelect={onRowsSelect}
                    keyField="id"
                    data={businessEmailTemplatesList.items.map(item => {
                      return {
                        ...item,
                        // TODO
                        name: item.id,
                        email_type: "Email hóa đơn tạo mới"
                      }
                    })}
                    columns={columns}
                    page={businessEmailTemplatesList?.params?.currentPage ?? 1}
                    sizePerPage={businessEmailTemplatesList?.params?.perPage ?? 10}
                    totalSize={3}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    // optionShowColumnHandel={optionShowColumnHandler}
                    // rowEvents={rowEventsHandler}
                    listRowAction={listRowAction}
                    loading={loadingList}
                  >
                    <div
                      onClick={() => clickCreateEmailTemplateHandler()}
                      className="btn btn-primary btn-label"
                    >
                      <i className="fas fa-plus label-icon" />
                      {t("title.create")}
                    </div>
                  </RemoteDataTable>
                  }
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <Row>
          {/* Modal START*/}
          <Col className="col-12">
            <ConfirmModal
              isOpen={deleteEmailTemplateModal}
              titleHeader={t("table.delete.confirm.header")}
              titleBody={t("table.delete.confirm.body")}
              onConfirm={clickDeleteEmailTemplateHandler}
              textBtnConfirm={t("table.delete.confirm.agree")}
              textBtnCancel={t("table.delete.confirm.cancel")}
              toggle={toggleDeleteEmailTemplateModal}
            />
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

BusinessEmailTemplateList.propTypes = {
  filterList: PropTypes.object,
};

BusinessEmailTemplateList.defaultProps = {
  filterList: {},
  pageView: "",
};


export default BusinessEmailTemplateList;
